import React, { ComponentProps } from 'react'

import { useBuyContext } from '@Components/BuyButton/hooks'
import { Button } from '@CoreComponents/Buttons/Button'
import { useTranslation } from '@Globals/Translations'

export const BuyButton = ({
  children,
  className,
  disabled,
  fillWidth = true,
  theme = 'primary',
  ...buttonProps
}: Omit<ComponentProps<typeof Button>, 'onClick'>) => {
  const {
    handleAddToCart,
    isDisabled: ctxDisabled,
    isLoading,
  } = useBuyContext()
  const { t } = useTranslation()

  return (
    <Button
      {...buttonProps}
      className={className}
      disabled={ctxDisabled || disabled}
      fillWidth={fillWidth}
      loading={isLoading}
      onClick={handleAddToCart}
      theme={theme}
    >
      {children || t('cms:ADD_TO_CART')}
    </Button>
  )
}
